/* GS PL: somente textos do Releasit. Carregar após content_for_header,
 * sincronamente antes dos scripts defer do app. Não altera checkout/handlers. */
(function () {
  'use strict';
  var diagnostic = {version: '20261001-1', configPresent: false, applied: 0};
  var host = window.location && window.location.hostname;
  if (host !== 'outllet-pl.shop' && host !== 'bx1xhc-ap.myshopify.com') return;
  if (window.Shopify && window.Shopify.shop && window.Shopify.shop !== 'bx1xhc-ap.myshopify.com') return;
  var config = window._RSI_COD_FORM_SETTINGS;
  if (!config || typeof config !== 'object') { window.GS_PL_RSI_I18N = diagnostic; return; }
  diagnostic.configPresent = true;
  var texts = {
    'OBJEDNEJTE A ZAPLAŤTE PŘI DORUČENÍ': 'ZAMÓW I ZAPŁAĆ PRZY ODBIORZE',
    'Mezisoučet': 'Suma częściowa',
    'Doprava': 'Dostawa',
    'Celková částka k zaplacení': 'Łączna kwota do zapłaty',
    'Způsob doručení': 'Sposób dostawy',
    'Digite um código de desconto válido.': 'Wpisz prawidłowy kod rabatowy.',
    'Zadejte prosím platnou e-mailovou adresu.': 'Wpisz prawidłowy adres e-mail.',
    'Zadejte prosím platnou hodnotu.': 'Wpisz prawidłową wartość.',
    'Apenas 1 desconto por pedido é permitido.': 'Można użyć tylko jednego rabatu na zamówienie.',
    'Toto pole je povinné.': 'To pole jest wymagane.',
    'Zdarma': 'Bezpłatnie',
    'Digite seu endereço de entrega': 'Wpisz adres dostawy',
    'Jméno': 'Imię',
    'Příjmení': 'Nazwisko',
    'Telefonní číslo': 'Numer telefonu',
    'E-mailová adresa': 'Adres e-mail',
    'Zadejte adresu, na které Vás kurýr může zastihnout a doručit zásilku mezi 08:00 a 16:00.': 'Podaj adres, pod którym kurier może Cię zastać i doręczyć przesyłkę w godzinach 08:00–16:00.',
    'PSČ': 'Kod pocztowy',
    'Ulice a číslo': 'Ulica i numer domu',
    'Patro / číslo bytu': 'Piętro / numer mieszkania',
    'Kraj': 'Województwo',
    'Město / Obec': 'Miasto / Miejscowość',
    'Order note': 'Uwagi do zamówienia',
    'Subscribe to stay updated with new products and offers!': 'Zapisz się, aby otrzymywać informacje o nowych produktach i ofertach!',
    'Accept our <a href="/policies/terms-of-service">terms and conditions</a>': 'Akceptuję <a href="/policies/terms-of-service">regulamin</a>',
    'nebo': 'lub',
    '20% sleva': '20% rabatu',
    'Zaplaťte online': 'Zapłać online',
    'Todos os impostos incluídos.': 'Wszystkie podatki wliczone.',
    'Código de desconto': 'Kod rabatowy',
    'Descontos': 'Rabaty',
    'Aplicar': 'Zastosuj',
    'K Vaší objednávce jste získali exkluzivní dárek.': 'Do zamówienia otrzymujesz wyjątkowy prezent.',
    'Doprava zdarma': 'Bezpłatna dostawa',
    'Default rate': 'Stawka standardowa',
    'Expresní doručení': 'Dostawa ekspresowa',
    'Taxa de pagamento na entrega': 'Opłata za płatność przy odbiorze',
    'Add {product_name} to your order!': 'Dodaj {product_name} do zamówienia!',
    'Add to my order': 'Dodaj do zamówienia',
    'No thank you, complete my order': 'Nie, dziękuję. Zakończ zamówienie',
    'A new code was sent via SMS to your phone number {phone_number}. Enter the code above.': 'Nowy kod wysłano SMS-em na numer {phone_number}. Wpisz go powyżej.',
    'Verify': 'Zweryfikuj',
    'Resend code': 'Wyślij kod ponownie',
    "Didn't receive your code?": 'Nie otrzymano kodu?',
    'Change phone number': 'Zmień numer telefonu',
    'You have reached the limit of resends, please try again with a different phone number.': 'Osiągnięto limit ponownego wysyłania. Spróbuj z innym numerem telefonu.',
    'Verify your phone number to complete your order': 'Zweryfikuj numer telefonu, aby zakończyć zamówienie',
    'A verification code was sent via SMS/WhatsApp to your phone number {phone_number}. Enter your code below to verify your phone number:': 'Kod weryfikacyjny wysłano przez SMS/WhatsApp na numer {phone_number}. Wpisz go poniżej, aby zweryfikować numer telefonu:',
    'Your code': 'Twój kod',
    'The code you entered is not valid, please try again.': 'Wpisany kod jest nieprawidłowy. Spróbuj ponownie.',
    'Cash on Delivery is not available for orders above $1000, please use a different payment method.': 'Płatność przy odbiorze nie jest dostępna dla zamówień powyżej $1000. Wybierz inną metodę płatności.',
    'Cash on Delivery (COD)': 'Płatność przy odbiorze (COD)',
    'Poland': 'Polska'
  };
  var groups = ['buyNowButton', 'form', 'messOtp', 'shippingRates', 'codFee', 'upsells', 'visiblity', 'general', 'localization'];
  var skip = {backendFields: true, style: true, titleStyle: true, tracking: true, integrations: true};
  function translate(object) {
    if (!object || typeof object !== 'object') return;
    Object.keys(object).forEach(function (key) {
      if (skip[key]) return;
      var value = object[key];
      if (typeof value === 'string' && Object.prototype.hasOwnProperty.call(texts, value)) {
        object[key] = texts[value]; diagnostic.applied += 1;
      } else if (value && typeof value === 'object') translate(value);
    });
  }
  groups.forEach(function (group) { translate(config[group]); });
  window.GS_PL_RSI_I18N = diagnostic;
})();
